import { expandCarouselPosts } from './carouselGroups';
import { Post } from './types';

type CommitCollectionAssignmentArgs = {
    posts: Record<string | number, Post>;
    postIds: Array<string | number>;
    collectionIds: number[];
    addCollectionsToPosts: (
        postIds: Array<string | number>,
        collectionIds: number[],
    ) => Promise<unknown> | unknown;
    closeModal: () => void;
    clearSelection: () => void;
    notifySuccess: (message: string) => void;
};

/**
 * Applies collection ids after the assignment API has already succeeded.
 * A follow-up getPosts(page 0) clears loaded posts and then refetches every
 * page, so assignment does not refresh pagination.
 */
export const commitCollectionAssignment = async ({
    posts,
    postIds,
    collectionIds,
    addCollectionsToPosts,
    closeModal,
    clearSelection,
    notifySuccess,
}: CommitCollectionAssignmentArgs) => {
    await addCollectionsToPosts(
        expandCarouselPosts(posts, postIds),
        collectionIds,
    );
    closeModal();
    clearSelection();
    notifySuccess(`Posts (${postIds.length}) Assigned Successfully!`);
};
